import { formatSalesValue } from "../../utils/formatUtils";

const ItemSoldTable = ({ data }) => {
    const aggregateItems = (type) => {
        const items = {};
        data.forEach(employee => {
            if (employee.Items_Sold && Array.isArray(employee.Items_Sold[type])) {
                employee.Items_Sold[type].forEach(item => {
                    if (!items[item.ItemName]) {
                        items[item.ItemName] = {
                            quantity: 0,
                            amount: 0,
                            Group: item.Group
                        };
                    }
                    items[item.ItemName].quantity += item.TotalQuantity;
                    items[item.ItemName].amount += item.TotalAmount;
                });
            }
        });

        return Object.entries(items)
            .map(([itemName, details]) => ({
                itemName,
                ...details
            }))
            .sort((a, b) => b.quantity - a.quantity);
    };

    const foodItems = aggregateItems('Food');
    const beverageItems = aggregateItems('Beverage');

    const calculateTotals = (items) => {
        return {
            count: items.reduce((sum, item) => sum + item.quantity, 0),
            amount: items.reduce((sum, item) => sum + item.amount, 0),
            itemCount: items.length
        };
    };

    const foodTotals = calculateTotals(foodItems);
    const beverageTotals = calculateTotals(beverageItems);

    return (
        <div className='flex gap-12'>
            <div className="w-1/2">
                <div className="rounded-md border overflow-auto max-h-[500px] tiny-scrollbar">
                    <table className="min-w-full divide-y divide-gray-200 text-sm text-center">
                        <thead className="bg-gray-100 sticky top-0">
                            <tr>
                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Group</th>
                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Food Items</th>
                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Quantity</th>
                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Amount</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-100">
                            {foodItems.length > 0 ? (
                                foodItems.map((item, index) => (
                                    <tr key={`food-${index}`} className="hover:bg-gray-50">
                                        <td className="p-2">{item.Group}</td>
                                        <td className="p-2">{item.itemName}</td>
                                        <td className="p-2">{item.quantity}</td>
                                        <td className="p-2">{item.amount.toFixed(2)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4} className="px-3 py-4 text-gray-500">No food data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="mt-2 p-2 space-y-1">
                    <div className='grid grid-cols-2 gap-2'>
                        <label className="mr-2">Total Item Count :</label>
                        <input
                            type="text"
                            readOnly
                            value={foodTotals.itemCount}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Total Items Sold :</label>
                        <input
                            type="text"
                            readOnly
                            value={foodTotals.count}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Total Amount :</label>
                        <input
                            type="text"
                            readOnly
                            value={formatSalesValue(foodTotals.amount)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />
                    </div>
                </div>
            </div>

            <div className="w-1/2">
                <div className="rounded-md border overflow-auto max-h-[500px] tiny-scrollbar">
                    <table className="min-w-full divide-y divide-gray-200 text-sm text-center">
                        <thead className="bg-gray-100 sticky top-0">
                            <tr>
                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Group</th>
                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Beverage Items</th>
                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Quantity</th>
                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Amount</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-100">
                            {beverageItems.length > 0 ? (
                                beverageItems.map((item, index) => (
                                    <tr key={`beverage-${index}`} className="hover:bg-gray-50">
                                        <td className="p-2">{item.Group}</td>
                                        <td className="p-2">{item.itemName}</td>
                                        <td className="p-2">{item.quantity}</td>
                                        <td className="p-2">{item.amount.toFixed(2)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4} className="px-3 py-4 text-gray-500">No beverage data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="mt-2 p-2 space-y-1">
                    <div className='grid grid-cols-2 gap-2'>
                        <label className="mr-2">Total Item count :</label>
                        <input
                            type="text"
                            readOnly
                            value={beverageTotals.itemCount}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Total Items sold :</label>
                        <input
                            type="text"
                            readOnly
                            value={beverageTotals.count}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Total Amount :</label>
                        <input
                            type="text"
                            readOnly
                            value={formatSalesValue(beverageTotals.amount)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemSoldTable;